import type { Enums } from "@msuite/utils/types";
import { Icon } from "../icons";
import { getScopeIcon } from "../icons/get-scope-icon";
import { localized } from "../localization";

/** Props Interface */
interface ScopeProps {
	scope: Enums<"scope">;
}

export function ScopeTag({ scope }: ScopeProps) {
	return (
		<div className="h-stack">
			<Icon
				name={getScopeIcon(scope)}
				style={{
					stroke: "var(--color-primary-500)",
				}}
			/>
			<p>{localized(`general.scope_${scope}`)}</p>
		</div>
	);
}
